import { render, staticRenderFns } from "./NuevaSanMiguel.vue?vue&type=template&id=67bf6177&scoped=true&"
import script from "./NuevaSanMiguel.vue?vue&type=script&lang=js&"
export * from "./NuevaSanMiguel.vue?vue&type=script&lang=js&"
import style0 from "./NuevaSanMiguel.vue?vue&type=style&index=0&id=67bf6177&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf6177",
  null
  
)

export default component.exports